import React from "react"
import tw, { css, styled } from "twin.macro"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"

import { SlideProps } from "."

import Container from "../components/container"
import NextPageButton from "../components/nextPageButton"
import SlideSection from "../components/slideSection"
import NextPageContainer from "../components/nextPageContainer"

const Header = styled.h2`
  ${tw`md:block text-center font-sans text-2xl mb-6`}
`

const Description = styled.p`
  ${tw`text-center font-sans text-sm mb-6`}
`

const HomeGrownSlide: React.SFC<SlideProps> = ({
  slideVisible,
  nextButtonClicked,
}) => {

  const data = useStaticQuery(query);

  const leftSource = [
    {
      ...data.homeGrown.childImageSharp.fixed,
      media: `(min-width: 368px)`,
    },
  ]

  return (
    <SlideSection fullHeight>
      <div css={[tw`flex flex-col items-center justify-center w-full h-full`]}>
        <div className="left-right-content-wrapper" css={[tw`flex flex-row h-full justify-end items-end lg:(relative items-center)`]}>
          <div id="home-grown-image-wrapper" css={[
            tw`absolute inset-0 flex flex-row justify-center items-start lg:(inset-y-0 right-auto)`,
            tw`transition duration-500 ease-out delay-100`,
            !slideVisible && tw`opacity-0 transform -translate-x-16`
          ]}>
            <Img
              style={{ height: '100%' }}
              fixed={leftSource}
              imgStyle={{ objectFit: 'contain', objectPosition: 'top' }}
            />
          </div>
          {/* relative to make the ordering correct */}
          <div className="text-wrapper" css={[tw`relative`]}>
            <Header css={[tw`font-text font-bold leading-8 text-standard-title text-center text-3xl md:text-5xl`, css`line-height: 1.2em;`]}>
              Home-grown talent
            </Header>
            <p css={[tw`font-text leading-7 md:leading-8 text-sm tracking-normal text-center`]}>
              Helping a young person grow a career on home soil nurtures the future of the entire automotive industry. Training your own Apprentice is also
              a great way to support the needs of your business as well as ensuring your team is up-to-date with the latest industry requirements.
            </p>
          </div>
        </div>
        <NextPageContainer>
          <NextPageButton
            onClick={nextButtonClicked}
            label=""
          />
        </NextPageContainer>
      </div>
    </SlideSection>
  )
}

export const query = graphql`
  query {
    homeGrown: file(relativePath: { eq: "HomeGrown.png" }) {
      childImageSharp {
        fixed(width: 700, quality: 100) {
          ...GatsbyImageSharpFixed_noBase64
        }
        fluid(maxWidth: 2000, quality: 100) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
  }
`

export default HomeGrownSlide
